<div id="container" >
    <div>
        <img src="../../../../assets/project_image.png" alt=""/>
    </div>
    <div id="{{project.id}}" contenteditable="true" (click)="selectAll()" (blur)="updateTitle()">
        <div class="title" id="{{project.id}}" contenteditable="true" (blur)="updateTitle()" badge="" spellcheck="false">{{title}}</div>
    </div>
   
</div>
